import { createNode } from '@glueapp/graph-types';

export const FunctionOutputsNode = createNode({
    id: 'function-outputs',
    name: 'Function Outputs',
    description: 'Manages output interface for this function',
    aiDescription: [
        'Internal function-system node — auto-created inside each function, not user-addable.',
        "Its input ports are dynamically generated from the containing function's outputPortDefinitions via computeShape.",
        "You cannot configure this node directly; edit the function definition's output ports instead.",
    ].join('\n'),
    category: 'Function System',
    color: '#FF9800',
    findableInLibrary: false, // Only auto-created, not user-addable
    hideInherentOutPort: true,
    inPorts: {},
    outPorts: {}, // No output ports - this collects final values

    computeShape: ({ containingFunctionDefinition }) => {
        // Compute inPorts from the current function's output port definitions
        const inPorts =
            containingFunctionDefinition?.outputPortDefinitions?.map(def => ({
                name: def.name,
                type: def.type,
                optional: def.optional || false,
            })) || [];

        return {
            inPorts,
            outPorts: [], // Function outputs have no output ports
        };
    },

    // This execute function does not run during graph execution.
    // The graph's general execution logic does the wiring of extracting results from this node's input directly.
    execute: () => {
        return {
            output: {},
        };
    },
});
